<script>
import padStart from 'lodash/padStart'
import formatDate from '@utils/format-date'
import { MONTH_TIME_FORMAT } from '@utils/constant'
import {
  measureListAgentComputed,
  measureListAgentMethods,
} from '@state/helpers/measure-list-agent'
import cloneDeep from 'lodash/cloneDeep'
import measureItems from './measureItems'
import compareItems from './compareItems'
import configChart from './configChart'

export default {
  page: {
    title: 'Measure List Agent',
    meta: [{ name: 'description', content: 'The Measure List Agent page.' }],
  },
  props: {
    format: {
      type: String,
      default: 'YYYY/MM',
      require: true,
    },
    pickerType: {
      type: String,
      default: '',
      require: false,
    },
    type: {
      type: String,
      default: 'month',
      require: false,
    },
  },
  data() {
    return {
      items: {},
      nowMonth: '',
      measureItems: measureItems,
      compareItems: compareItems,
      configChart: {
        label: '',
        config: cloneDeep(configChart),
      },
      compareMonth: '',
      itemChart: {
        data: [],
        backgroundColor: '',
        label: '',
      },
      datasets: [],
    }
  },
  computed: {
    ...measureListAgentComputed,
    measureDataComputed() {
      const measureList = cloneDeep(this.getOverview?.data)
      measureItems.map((item) => {
        const options = item.options?.map((field) => {
          field.value =
            measureList && measureList[0]
              ? measureList[0][field.key]
              : field.value
        })
        return options
      })
      return measureItems
    },
    compareDataComputed() {
      const currentList = cloneDeep(this.getOverview?.data)
      const compareList = cloneDeep(this.getCompare?.data)

      const data = compareItems.map((item) => {
        item.options = item.options.map((field) => {
          const newData = []

          if (currentList && currentList[0]) {
            newData.push(currentList[0][field.key])
          } else newData.push(0)

          if (compareList && compareList[0]) {
            newData.push(compareList[0][field.key])
          }

          field.data = [...newData]

          return field
        })
        return item
      })

      return data
    },
    countMembers() {
      if (this.getOverview) {
        return this.getOverview.members_count
      } else {
        return ''
      }
    },
    countUnuseds() {
      if (this.getOverview) {
        return this.getOverview.members_unused
      } else {
        return ''
      }
    },
    measureTimes() {
      if (this.getOverview) {
        return this.getOverview.measure_times_avg
      } else {
        return ''
      }
    },
  },
  created() {
    this.fetchOverview()
    this.fetchCompare()
    const user = this.$store.getters['auth/getCurrentUser']
    this.$router.replace({
      query: { agent_code: user?.agent?.agent_code },
    // eslint-disable-next-line handle-callback-err
    }).catch((error) => {})
  },
  methods: {
    ...measureListAgentMethods,
    fetchOverview() {
      this.getNowMonth()
      const payload = {
        compare_date: this.getNowMonth(),
      }
      this.fetchingOverview(payload)
    },
    fetchCompare() {
      this.compareMonth = this.getLastMonth()
      const payload = {
        compare_date: this.getLastMonth(),
      }
      this.fetchingCompare(payload)
    },
    getNowMonth() {
      var nowDate = new Date().getDate()
      if (nowDate === 1) {
        this.nowMonth =
          new Date().getFullYear() +
          '/' +
          padStart(new Date().getMonth(), 2, '0')
      } else {
        this.nowMonth = formatDate(new Date(), MONTH_TIME_FORMAT)
      }
      return this.nowMonth
    },
    changeLabel(date) {
      const year = date.split('/').[0].concat('年')
      const month = date.split('/').[1].concat('月')
      return year.concat(month)
    },
    getLastMonth() {
      var nowDate = new Date().getDate()
      if (nowDate === 1) {
        const month = new Date().getMonth() - 1
        return new Date().getFullYear() + '/' + padStart(month, 2, '0')
      } else {
        return (
          new Date().getFullYear() +
          '/' +
          padStart(new Date().getMonth(), 2, '0')
        )
      }
    },
    handleUpdate(value) {
      this.compareMonth = value
      const payload = {
        compare_date: value,
      }
      this.fetchingCompare(payload)
    },
  },
}
</script>

<template>
  <div>
    <BaseCardDetail title="計測情報" form-collapsed>
      <template v-slot:header-action>
        <div></div>
      </template>
      <template>
        <CRow>
          <div class="col-md-4">
            <CCard class="pt-3 count bg-count" align="center">
              <p>ユーザ数</p>
              <p class="count-number">{{ countMembers }}<small>人</small></p>
            </CCard>
          </div>
          <div class="col-md-4">
            <CLink
              :to="
                `/panel/member-list-agent-admin?key=search_unused_members&value=1`
              "
              ><CCard class="pt-3 count bg-unused" align="center">
                <p>当月未計測ユーザ数</p>
                <p class="count-number">{{ countUnuseds }}<small>人</small></p>
              </CCard></CLink
            >
          </div>
          <div class="col-md-4">
            <CCard class="pt-3 count bg-measure" align="center">
              <p>当月計測ユーザ数の平均計測回数</p>
              <p class="count-number">{{ measureTimes }}<small>回</small></p>
            </CCard>
          </div>
        </CRow>

        <h5 class="card-title">計測情報比率</h5>
        <CRow class="measure-item">
          <div
            v-for="(item, index) in measureDataComputed"
            :key="index"
            class="col-md-4"
          >
            <CCard class="p-3">
              <h5 class="card-title">{{ item.label }}</h5>
              <div v-for="(option, i) in item.options" :key="i" class="row">
                <p class="col-4">{{ option.label }}</p>
                <div class="col-8">
                  <CLink
                    :to="
                      `/panel/member-list-agent-admin?key=${item.keySearch}&value=${option.range}`
                    "
                  >
                    <CProgress
                      :value="option.value"
                      show-value
                      :color="option.color"
                      show-percentage
                      style="height:16px;"
                      class="mt-1"
                    />
                  </CLink>
                </div>
              </div>
            </CCard>
          </div>
        </CRow>
      </template>
    </BaseCardDetail>

    <BaseCardDetail title="比較" form-collapsed>
      <template v-slot:header-action>
        <div></div>
      </template>
      <div class="d-flex align-items-center">
        <p class="pr-4">比較先</p>
        <BaseDatePicker
          :format="format"
          :type="type"
          :picker-type="pickerType"
          :init-date="getLastMonth()"
          :readonly-input="true"
          :disabled-after="new Date()"
          :hide-today="true"
          :hide-clear="true"
          range
          @update:date="(v) => handleUpdate(v)"
        />
      </div>
      <CRow>
        <div
          v-for="(item, index) in compareDataComputed"
          :key="index"
          class="col-md-4 mt-3"
        >
          <p class="text-center font-weight-bold">{{ item.label }}</p>
          <CChartHorizontalBar
            :labels="[changeLabel(nowMonth), changeLabel(compareMonth)]"
            :datasets="item.options"
            :options="configChart.config.options"
          />
        </div>
      </CRow>
    </BaseCardDetail>
  </div>
</template>

<style lang="scss" scoped>
.count {
  color: #fff;

  &.bg-count {
    background-color: #a1cb5e;
  }
  &.bg-unused {
    background-color: #63c2de;
  }
  &.bg-measure {
    /* background-color: #b78837; */
    background-color: #cfa65f;
  }
  &-number {
    font-size: 25px;
    font-weight: bold;
  }
}
.card-title {
  margin-bottom: 0.75rem;
  font-weight: 600;
  color: #73818f;
}
::v-deep .bg-blue {
  background-color: #20a8d8 !important;
}
::v-deep .bg-green {
  background-color: #4dbd74 !important;
}
::v-deep .bg-yellow {
  background-color: #ffc107 !important;
}
::v-deep .bg-red {
  background-color: #f86c6b !important;
}
::v-deep .bg-primary {
  background-color: #a8cf6a !important;
}
::v-deep .bg-purple {
  background-color: #6f42c1 !important;
}
::v-deep .bg-transparent {
  background-color: #c8ced3 !important;
}
a:hover {
  text-decoration: none;
}
::v-deep .progress {
  background-color: #c8ced3;
}
::v-deep .progress-bar {
  overflow: visible !important;
}
</style>
